interface DottedNameListProps {
    names: string[];
    textColorClass: string;
    dotColorClass: string;
}

const DottedNameList = (props: DottedNameListProps) => {
    return (
        <div className="flex flex-wrap gap-x-s gap-y-xxs items-center">
            {props.names.map((name, index) => (
                <div
                    key={index}
                    className="flex gap-s items-center shrink-0"
                >
                    {index > 0 && <div className={`w-[6px] h-[6px] rounded-circle shrink-0 ${props.dotColorClass}`} />}
                    <span className={`text-m whitespace-nowrap ${props.textColorClass}`}>{name}</span>
                </div>
            ))}
        </div>
    );
};

export default DottedNameList;
